const columns = document.querySelectorAll('.block-stat-simple .block-stat');
const topHeadings = document.querySelectorAll(
	'.block-stat-simple__container > p, .block-stat-simple__container > .wp-block-heading'
);

if (columns) {
	columns.forEach((column, index) => {
		column.setAttribute('data-aos', 'fade');
		column.setAttribute('data-aos-duration', '800');
		column.setAttribute('data-aos-delay', `${index * 100}`);
	});
}

if (topHeadings) {
	topHeadings.forEach((el) => {
		el.setAttribute('data-aos', 'fade');
		el.setAttribute('data-aos-duration', '800');
		el.setAttribute('data-aos-delay', '0');
	});
}

const container = document.querySelector('.block-stat-simple__top-img-con');
const title = container.querySelector('.block-stat-simple__big-title');
const image = container.querySelector('img');

function animateOnScroll() {
	const rect = container.getBoundingClientRect();
	const winHeight = window.innerHeight;

	const start = winHeight; // when element just enters bottom of viewport
	const end = -rect.height; // when it's fully above viewport
	const progress = (start - rect.top) / (start - end);

	const clampedProgress = Math.min(Math.max(progress, 0), 1);

	// Title translate: from 100% to -100%
	const translateX = 100 - clampedProgress * 200;
	title.style.transform = `translate(${translateX}%, -50%)`;

	// Image scale: from 1 to 1.25 over the first 50% of scroll
	const scaleProgress = Math.min(clampedProgress * 2, 1); // cap at 1
	const scale = 1 + scaleProgress * 0.25;
	image.style.transform = `scale(${scale})`;

	requestAnimationFrame(animateOnScroll);
}

requestAnimationFrame(animateOnScroll);
